export default "__VITE_ASSET__d400b5f8__"